import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "antd";
import { EyeOutlined, HeartOutlined } from "@ant-design/icons";
import { BlankSpace, PageContainer } from "../../../component/Xcomponent";

import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";

import { ArticleCard } from "./ArticleListStyle";

/* actions */
import {
  getArticleList,
  getArticleListReset,
} from "../../../action/getArticleListAction";

import { s3_cdn } from "../../../utils";

// Icons
import { DotIcon } from "../../../component/CustomIcons";
import HeaderContext from "../../../context/HeaderContext";

const ArticleList = (props) => {
  /* variables */
  const { getArticleList, getArticleListReset, getArticleListState } = props;
  const location = useLocation();
  const {setTitle} = useContext(HeaderContext);

  // Callback
  useEffect(() => {
    let article_type = "";
    switch (location.pathname) {
      case "/article-read":
        article_type = "text";
        setTitle("Read Blogs");
        break;
      case "/article-watch":
        article_type = "video";
        setTitle("Watch Videos");
        break;
      case "/article-listen":
        article_type = "audio";
        setTitle("Listen Audios");
        break;
      default:
        article_type = "";
        break;
    }
    getArticleList({ type: article_type });
  }, [location]);
  useEffect(() => {
    return () => {
      getArticleListReset();
    };
  }, []);

  return (
    <PageContainer>
      {getArticleListState.list.length > 0 && (
        <>
          <Row gutter={[20, 20]}>
            {getArticleListState.list.map((data) => (
              <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                {console.log(data)}
                <Link to={`article-detail/${data.slug}`}>
                  <ArticleCard
                    cover={
                      <img
                        alt="example"
                        src={`${s3_cdn()}article/${data.image_path}`}
                      />
                    }
                  >
                    <div className="description">
                      <p>{data.title}</p>
                      <div className="views">
                        <span>
                          {moment(data.createdAt).format("Do MMM YYYY")}
                        </span>
                        <span style={{ margin: "0 2px" }}>
                          <DotIcon size="6" height="6" />
                        </span>
                        <EyeOutlined />
                        <span>{data.views} views</span>
                        <span style={{ margin: "0 2px" }}>
                          <DotIcon size="6" height="6" />
                        </span>
                        <HeartOutlined />
                        <span>{data.likes} Likes</span>
                      </div>
                    </div>
                  </ArticleCard>
                </Link>
              </Col>
            ))}
          </Row>
          <BlankSpace />
        </>
      )}
    </PageContainer>
  );
};

const mapStateToProps = (state) => ({
  getArticleListState: state.getArticleList,
});

const mapDispatchToProps = (dispatch) => ({
  getArticleList: (params) => dispatch(getArticleList(params)),
  getArticleListReset: () => dispatch(getArticleListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticleList);
